/**
 * @description 商品 ID (enum)
 */
export enum ProductIdEnum {
  /** 旅平險 */
  Travel = 'Travel',
  /** 定期壽險 */
  Life = 'Life'
}
